import PropTypes from "prop-types"
import React from "react"
import classNames from "classnames"
import KeyTranslator from "utils/key_translator"
import _ from "underscore"

const { string, number, arrayOf, oneOfType, shape, func } = PropTypes

export default class extends React.Component {
  static displayName = "Autocomplete"

  static propTypes = {
    value: string,
    placeholder: string,
    results: arrayOf(
      shape({
        value: oneOfType([number, string]).isRequired,
        name: string.isRequired
      })
    ),
    onChange: func.isRequired,
    onSelect: func.isRequired,
    onBlur: func
  }

  static defaultProps = {
    value: "",
    results: [],
    onBlur: _.noop
  }

  state = { selectedIndex: 0 }

  UNSAFE_componentWillReceiveProps(_nextProps) {
    this.setState({ selectedIndex: 0 })
  }

  // eslint-disable-next-line consistent-return
  handleKeyDown = event => {
    switch (KeyTranslator.translate(event)) {
      case "up":
        this.moveSelection(-1)
        break
      case "down":
        this.moveSelection(1)
        break
      case "enter":
        this.chooseSelectedResult()
        break
      case "escape":
        this.handleBlur()
        break
      default:
        return null
    }
  }

  handleBlur = () => {
    this.props.onBlur()
  }

  handleMouseEnter = index => {
    this.setState({ selectedIndex: index })
  }

  moveSelection = motion => {
    const newIndex = this.state.selectedIndex + motion
    const length = this.props.results.length

    if (newIndex > length - 1) {
      this.setState({ selectedIndex: 0 })
    } else if (0 > newIndex) {
      this.setState({ selectedIndex: length - 1 })
    } else {
      this.setState({ selectedIndex: newIndex })
    }
  }

  chooseSelectedResult = () => {
    const result = this.props.results[this.state.selectedIndex]
    result && this.props.onSelect(result.value)
  }

  getResultClassName = resultIndex => {
    const { selectedIndex } = this.state

    return classNames("autocomplete-result", {
      highlighted: resultIndex === selectedIndex
    })
  }

  render() {
    const { value, placeholder, results, onChange, onSelect } = this.props

    return (
      <div style={{ position: "relative" }}>
        <input
          type="text"
          value={value}
          placeholder={placeholder}
          onBlur={this.handleBlur}
          onKeyDown={this.handleKeyDown}
          autoComplete="off"
          onChange={event => onChange(event.target.value)}
        />
        <div className="autocomplete">
          <ul className="autocomplete-results">
            {results.map((result, i) => {
              return (
                <li
                  className={this.getResultClassName(i)}
                  key={result.value}
                  onTouchStart={() => onSelect(result.value)}
                  onMouseDown={() => onSelect(result.value)}
                  onMouseEnter={() => this.handleMouseEnter(i)}
                >
                  <span className="autocomplete-result__link">{result.name}</span>
                </li>
              )
            })}
          </ul>
        </div>
      </div>
    )
  }
}
